import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { SidebarComponent } from '@/sidebar/sidebar.component';
import { SplitterModule } from 'primeng/splitter';
import { RippleModule } from 'primeng/ripple';
import { ButtonModule } from 'primeng/button';
import { feedback } from '@/common/sentry/feedback';
import { AfterViewInit, ViewChild, ElementRef, OnInit } from '@angular/core';
import { environment } from '@env/environment';
import { SyncAlertBannerComponent } from './sync-alert-banner/sync-alert-banner.component';

@Component({
    selector: 'app-layout-auth',
    imports: [
        SidebarComponent,
        RouterOutlet,
        ButtonModule,
        RippleModule,
        SidebarComponent,
        SplitterModule,
        SyncAlertBannerComponent,
    ],
    templateUrl: './auth.component.html',
    styleUrl: './auth.component.scss',
    // fill <main>, which grows with the page, so the white card does too
    host: {
        class: 'flex flex-1',
    },
})
export class LayoutAuthComponent implements OnInit, AfterViewInit {
	showFeedbackButton = false;
	// Method to show the Sentry feedback dialog
  @ViewChild('feedbackButton', { static: false }) feedbackButton!: ElementRef;

	constructor() {}

	ngOnInit(): void {
		// Set the property based on the environment
		this.showFeedbackButton = environment.sentryENV !== 'local';
	}

	ngAfterViewInit(): void {
      if (this.feedbackButton && 'local' !== environment.sentryENV) {
        feedback.attachTo(this.feedbackButton.nativeElement, {
          // Optional: Override options here if needed
          formTitle: 'Crowd Favorite Support',
        });
      }
    }
}
